import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { List } from 'foundations-components/transitional/components/List';
import { ActionButton, PauseActionButton } from 'commerce-subscription-lib/public/components';
import { useSubscriptionActions } from 'commerce-subscription-lib/public/hooks';
import { InvoiceCreation, SubscriptionActions } from 'commerce-subscription-lib/public/types';
import { Dropdown, DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const {
  Edit,
  UpdatePaymentMethod,
  Cancel,
  EditNextBillingDate,
  Pause,
  Delete
} = SubscriptionActions;
export function SubscriptionSidebarActions({
  invoiceCreation
}) {
  const actions = useSubscriptionActions();
  const [open, setOpen] = useState(false);
  const revalidate = e => {
    const shouldOpen = e.target.value;
    if (shouldOpen) {
      void actions[Cancel].revalidate();
    }
    setOpen(shouldOpen);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [invoiceCreation === InvoiceCreation.On && /*#__PURE__*/_jsx(TFlex, {
      justify: "end",
      children: /*#__PURE__*/_jsx(Dropdown, {
        buttonUse: "transparent",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.Actions.label"
        }),
        "data-selenium-test": "subscription-sidebar-actions",
        "data-test-id": "subscription-sidebar-actions",
        open: open,
        onOpenChange: revalidate,
        children: /*#__PURE__*/_jsxs(List, {
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "edit-subscription-button",
            action: actions[Edit],
            actionType: Edit
          }), /*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "update-payment-method-button",
            action: actions[UpdatePaymentMethod],
            actionType: UpdatePaymentMethod
          }), /*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "edit-next-payment-date-button",
            action: actions[EditNextBillingDate],
            actionType: EditNextBillingDate
          }), /*#__PURE__*/_jsx(PauseActionButton, {
            action: actions[Pause],
            actionType: Pause
          }), /*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "cancel-subscription-button",
            action: actions[Cancel],
            actionType: Cancel
          }), /*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "delete-subscription-button",
            action: actions[Delete],
            actionType: Delete
          })]
        })
      })
    }), invoiceCreation === InvoiceCreation.Off && /*#__PURE__*/_jsx(TFlex, {
      justify: "end",
      children: /*#__PURE__*/_jsx(Dropdown, {
        buttonUse: "transparent",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.Actions.label"
        }),
        "data-selenium-test": "subscription-sidebar-actions",
        "data-test-id": "subscription-sidebar-actions",
        open: open,
        onOpenChange: revalidate,
        children: /*#__PURE__*/_jsx(List, {
          wrapChildren: true,
          children: /*#__PURE__*/_jsx(ActionButton, {
            "data-test-id": "delete-subscription-button",
            action: actions[Delete],
            actionType: Delete
          })
        })
      })
    })]
  });
}